import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[pmSsnFormat]'
})
export class SsnFormatDirective {
    constructor(private el: ElementRef, private renderer: Renderer2,private control: NgControl) {}
    // Listener for key inputs (replaces invalid characters as user types)
    @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
        this.enforceNumericInput();
    }

    @HostListener('blur') onBlur() {
        this.formatSSN();
    }

    @HostListener('focus') onFocus() {
        this.removeFormatting();
    }

    // Enforces that only numeric characters are allowed in the input
    private enforceNumericInput() {
        let value = this.el.nativeElement.value.replace(/\D/g, ''); // Remove non-digit characters
        this.renderer.setProperty(this.el.nativeElement, 'value', value); // Update input field
    }

    private formatSSN() {
        let value = this.el.nativeElement.value.replace(/\D/g, ''); // Remove non-digit characters
        if (value.length === 9) {
            value = value.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
        }
        this.renderer.setProperty(this.el.nativeElement, 'value', value);

        this.control.control?.setValue(value);
    }

    private removeFormatting() {
        let value = this.el.nativeElement.value.replace(/\D/g, ''); // Remove non-digit characters
        this.renderer.setProperty(this.el.nativeElement, 'value', value);
    }

}
